import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MobileViewService } from '../../../../utils/shared-services/mobileView/mobileView.service';
import { CaptionService } from '../../../../utils/shared-services/caption.service';
import { StoreList } from '../../models/head-office-portal.model';
import { GroupWithItems } from '../../../store-groups/models/group-item.model';
import { Tag } from '../../../tags/models/tag.model';
import { StoreGroupMembersApiService } from '../../../store-groups/services/store-group-member.resource';
import { TagApiService } from '../../../tags/services/tag.resource';

@Component({
    selector: 'selectPrimaryStore',
    templateUrl: 'src/app/features/head-office-portal/templates/dialogs/select-ho-store.dialog.html',
    standalone: false
})
export class SelectHOStoreDialog {
    public filterByGroup = null;
    public filterByTag = null;
    public availableSearchStr: string = '';
    public allStores: any;
    public captions: any;
    public storeList: any;
    public totalStores: number = 0;
    public storeGroups: GroupWithItems[] = [];
    public selectedGroupItems: number[] = [];
    public tags: Tag[] = [];
    public selectedTags: number[] = [];

    constructor(
        @Inject(MatDialogRef) public dialogRef: MatDialogRef<SelectHOStoreDialog>,
        @Inject(MAT_DIALOG_DATA) public data: StoreList,
        @Inject(Router) public router: Router,
        @Inject(CaptionService) private captionService: CaptionService,
        @Inject(ActivatedRoute) public actRoute: ActivatedRoute,
        @Inject(MobileViewService) private mobileViewService: MobileViewService,
        @Inject(StoreGroupMembersApiService) private storeGroupMembersApiService: StoreGroupMembersApiService,
        @Inject(TagApiService) private tageApiService: TagApiService,
    ) {
        this.captions = this.captionService.captions;
        this.mobileViewService.setBreakpoint(MobileViewService.MOBILE_BREAKPOINT_MEDIUM);
        this.filterByGroup = this.captions.filterByGroup;
        this.filterByTag = this.captions.filterByTag;
    }

    ngOnInit() {
        this.storeList = this.data.storeList;
        this.storeGroups = this.data.storeGroups || []; 
        this.tags = this.data.tags || [];
        this.totalStores = this.data.totalStores || 0;
    }

    countStores(): number {
        return this.storeList.filter(store => store.isChecked).length;
    }

    submitSelectedStores(): void {
        const countStores = this.storeList
            .filter(store => store.isChecked)
            .map(store => ({
                storeID: store.id,
                storeName: store.displayName
            }));
        this.dialogRef.close(countStores);
    }

    setSelection(selection: number): void {
        this.storeList.forEach(store => {
            store.isChecked = selection === 0 ? true : selection === 1 ? false : !store.isChecked;
        });
    }

    applyGroupFilter(): void {
        if (!this.selectedGroupItems || this.selectedGroupItems.length === 0) {
            return;
        }

        const storeIDByGroup: number[] = [];
        this.selectedGroupItems.forEach(groupItemId => {
            this.storeGroupMembersApiService.getGroupItemInfoById(groupItemId).then(groupItemInfo => {
                storeIDByGroup.push(...groupItemInfo.map(item => item.id));
                this.storeList.forEach(store => {
                    store.isChecked = storeIDByGroup.includes(store.id);
                });
            });  
        });
    }

    applyTagFilter(): void {
        if (!this.selectedTags || this.selectedTags.length === 0) {
            return;
        }

        const storeIDByTag: number[] = [];
        this.selectedTags.forEach(tagId => {
            this.tageApiService.getStoresByTagID(tagId).then(stores => {
                storeIDByTag.push(...stores.map(store => store.id));
                this.storeList.forEach(store => {
                    store.isChecked = storeIDByTag.includes(store.id);
                });
            });
        });
    }

    cancelClicked() {
        this.dialogRef.close();
    }

    filterStore(store: any, searchTerm?: string) {
        return !searchTerm || store.displayName.toLowerCase().includes(searchTerm) || store.hoStore.STORENAME.toLowerCase().includes(searchTerm);
    }

}
